exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .v-autocomplete.v-input>.v-input__control>.v-input__slot{cursor:text}.qmodii .v-autocomplete input{align-self:center}.qmodii .v-autocomplete--is-selecting-index input{opacity:0}.qmodii .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot>input{margin-top:24px}.qmodii .v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input{pointer-events:inherit}.qmodii .v-autocomplete__content.v-menu__content,.qmodii .v-autocomplete__content.v-menu__content .v-card{border-radius:0}", ""]);

// exports
